import { CheckCircle, Circle, Clock } from 'lucide-react';
import { resolveEscrowUiState } from './transactionState';
import { Product as D } from './productTokens';

function Timeline({ transaction }) {
  const steps = [
    { label: 'Awaiting agreement', key: 'created' },
    { label: 'Awaiting payment', key: 'payment_received' },
    { label: 'Payment Protected', key: 'funds_secured' },
    { label: 'Delivery in progress', key: 'item_shipped' },
    { label: 'Awaiting buyer confirmation', key: 'delivery_confirmed' },
    { label: 'Funds released', key: 'funds_released' }
  ];
  const uiState = resolveEscrowUiState(transaction);

  const getStepStatus = (key) => {
    switch(key) {
      case 'created':
        return 'complete';
      case 'seller_confirmed':
        return transaction.seller_confirmed ? 'complete' : 'pending';
      case 'payment_received':
        return uiState.progressIndex >= 2 ? 'complete' : 'pending';
      case 'funds_secured':
        return uiState.progressIndex >= 3 ? 'complete' : 'pending';
      case 'item_shipped':
        return uiState.progressIndex >= 4 ? 'complete' : 'pending';
      case 'delivery_confirmed':
        return uiState.progressIndex >= 5 ? 'complete' : 'pending';
      case 'funds_released':
        return uiState.terminal ? 'complete' : 'pending';
      default:
        return 'pending';
    }
  };

  const getCurrentStep = () => {
    return Math.min(uiState.progressIndex, steps.length - 1);
  };

  const currentStep = getCurrentStep();

  return (
    <div data-testid="transaction-timeline" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {steps.map((step, index) => {
        const status = getStepStatus(step.key);
        const isActive = index === currentStep;
        const isComplete = status === 'complete';
        const dotColor = isComplete ? D.success : isActive ? D.accent : D.dim;
        const textColor = isComplete ? D.success : isActive ? D.accent : D.dim;

        return (
          <div key={step.key} style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{
                width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: `${dotColor}26`, color: dotColor, transition: 'all 0.15s',
              }}>
                {isComplete ? (
                  <CheckCircle style={{ width: 24, height: 24 }} />
                ) : isActive ? (
                  <Clock style={{ width: 24, height: 24 }} />
                ) : (
                  <Circle style={{ width: 24, height: 24 }} />
                )}
              </div>
              {index < steps.length - 1 && (
                <div style={{ width: 2, height: 32, background: isComplete ? `${D.success}66` : D.border }} />
              )}
            </div>
            <div style={{ flex: 1, paddingTop: 8 }}>
              <p style={{ margin: 0, fontWeight: 600, color: textColor }}>{step.label}</p>
              {isActive && (
                <p style={{ margin: '4px 0 0', fontSize: 13, color: D.sub }}>{uiState.secondaryLabel || 'In progress'}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Timeline;
